import { useState } from "react";
import { useForm } from "react-hook-form";
import { FormBase } from "../../../../interface/form-base";
import { BcOptionsArrayFieldProps } from "../../../../interface/props/bcarrayfields";
import {
  BCArrayFieldsCont,
  BCButton,
  BCFieldItem,
  BCFieldsCont,
  BCFieldsDelCont,
  BCFieldset,
} from "../../../../styled/global.styled";
import BcIcon from "../../../Bc-Icon/Bc-icon";
import SwitchFields from "../../../Bc-SwitchFields/Bc-SwitchFields";

const OptionsArrayField = ({ setValue, field, getValues }: BcOptionsArrayFieldProps) => {

  /** Estado de fields */
  const [fields, setFields] = useState<any[]>([]);
  const OptionSelect: FormBase[] = [
    {
      label: "Valor",
      item: "value",
      type: "text",
      isRequired: true
    },
    {
      label: "Nombre",
      item: "name",
      type: "text",
      isRequired: true
    },
  ];

  const {
    register,
    resetField,
    unregister,
    handleSubmit,
    formState: { isValid },
  } = useForm<any>({ mode: "onChange" });
  const onSubmit = handleSubmit(async (data) => {
    console.log(field);
    const addField = await data;
    const newFields = [...fields];
    newFields.push(addField);
    setFields(newFields);
    console.log("datos a validar --->",getValues(field.item))
    setValue(field.item, newFields);
    OptionSelect.forEach(async (field: FormBase) => {
      resetField(field.item);
    });
  });

  /** Metodo de agregar fields */
  const addFields = () => {
    onSubmit();
  };

  const deleteField = (fieldDelete: number) => {
    const updateFields = [...fields];
    updateFields.splice(fieldDelete, 1);
    setFields(updateFields);
    setValue(field.item, updateFields);
  };

  return (
    <BCArrayFieldsCont>
      <BCFieldset>
        <legend>{field.label}</legend>
        {OptionSelect &&
          OptionSelect.map((field: FormBase,) => (
            <SwitchFields
              key={`fieldsOptions${field.item}`}
              field={field}
              register={register}
              unregister={unregister}
              setValue={setValue}
              isRequired={true}
            />
          ))}
      </BCFieldset>
      <BCButton
        type="button"
        className="bc-button-primary bc-button-small"
        disabled={!isValid}
        onClick={() => addFields()}
      >
        Agregar {field.label}
      </BCButton>
      <BCFieldsCont>
        {fields.length > 0 ? (
          fields.map((itemField: any, index: number) => (
            <BCFieldItem key={`itemFieldOptions0${index}`}>
              <div>
                <h5>Datos a guardar</h5>
                {Object.keys(itemField).map((itemValue: any) => (
                  <p key={itemValue}>
                    <strong>{itemValue}:</strong> {itemField[itemValue]}
                  </p>
                ))}
              </div>
              <BCFieldsDelCont>
                <BCButton
                  type="button"
                  className="bc-button-primary bc-button-small"
                  onClick={() => deleteField(index)}
                >
                  <BcIcon iconName="error" />
                </BCButton>
              </BCFieldsDelCont>
            </BCFieldItem>
          ))
        ) : (
          <h4>Sin {field.label} agregados</h4>
        )}
      </BCFieldsCont>
    </BCArrayFieldsCont>
  );
};

export default OptionsArrayField;
